import { Checkbox, Divider, Input, InputNumber, Select } from 'antd'
import React from 'react'
import styled from 'styled-components'
import { MobileCountryCodeSelect } from '../MasterKeyFormComponent/Mobile/MobileCountryCodeSelect'
import { NationalitySelect } from '../MasterKeyFormComponent/Nationality/NationalitySelect'

export const CustomInputAttrs: Record<string, any> = {
  bordered: false,
  size: 'large',
  style: { background: '#fff', borderRadius: '10px', padding: '15px', color: '#0048B3' },
}
export const CustomLoginInput = styled(Input).attrs({ ...CustomInputAttrs })`
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus,
  & input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    -webkit-text-fill-color: #0048b3 !important;
    background-color: white !important;
    background-clip: content-box !important;
  }
`
export const CustomLoginInputPassword = styled(Input.Password).attrs({ ...CustomInputAttrs })`
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus,
  & input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    -webkit-text-fill-color: #0048b3 !important;
    background-color: white !important;
    background-clip: content-box !important;
  }
`
export const CustomLoginInputNumber = styled(InputNumber).attrs({
  ...CustomInputAttrs,
  style: { ...CustomInputAttrs.style, width: '100%' },
})`
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus,
  & input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
    -webkit-text-fill-color: #0048b3 !important;
    background-color: white !important;
    background-clip: content-box !important;
  }
`
export const CustomSelect = styled(Select).attrs({ ...CustomInputAttrs })``
export const CustomCheckbox = styled(Checkbox)`
  & > .ant-checkbox {
    border-radius: 100%;
    overflow: hidden;
    border: 1px solid #0048b3;
  }
  & > .ant-checkbox:not(.ant-checkbox-checked) {
    border-radius: 100%;
    overflow: hidden;
    border: 1px solid #0048b3;
    & span.ant-checkbox-inner {
      background-color: transparent;
      border-color: transparent;
    }
  }
`
export const CustomDivider = styled(Divider)`
  color: #0048b3 !important;
  border-top-color: #0048b3 !important;
`

export const CustomNationalitySelect = styled(
  React.forwardRef<any, any>((props, ref) => <NationalitySelect {...props} ref={ref} />),
).attrs({ ...CustomInputAttrs })``

export const CustomMobilePrefixSelect = styled(
  React.forwardRef<any, any>((props, ref) => <MobileCountryCodeSelect {...props} ref={ref} />),
).attrs({ ...CustomInputAttrs })``

export const CustomInputAttrsV2: Record<string, any> = {
  bordered: true,
  size: 'large',
  style: {
    background: '#fff',
    borderRadius: '10px',
    padding: '15px',
    color: '#0048B3',
    borderColor: '#D6DAE0',
  },
}

export const CustomSelectAttrsV2: Record<string, any> = {
  bordered: false,
  size: 'large',
  style: {
    background: '#fff',
    borderRadius: '10px',
    padding: '15px',
    color: '#0048B3',
  },
}

export const CustomLoginInputV2 = styled(Input).attrs({ ...CustomInputAttrsV2 })`
  &::placeholder {
    color: #667085 !important;
  }
  &:hover {
    border-color: #d6dae0 !important;
  }
  &:focus {
    border-color: #0048b3 !important;
    box-shadow: 0 0 0 2px rgba(0, 72, 179, 0.2) !important;
  }
`

export const CustomLoginInputPasswordV2 = styled(Input.Password).attrs({ ...CustomInputAttrsV2 })`
  &::placeholder {
    color: #667085 !important;
  }
  & input::placeholder {
    color: #667085 !important;
  }
  & .ant-input::placeholder {
    color: #667085 !important;
  }
  &:hover {
    border-color: #d6dae0 !important;
  }
  &:focus {
    border-color: #0048b3 !important;
    box-shadow: 0 0 0 2px rgba(0, 72, 179, 0.2) !important;
  }
  &:focus-within {
    border-color: #0048b3 !important;
    box-shadow: 0 0 0 2px rgba(0, 72, 179, 0.2) !important;
  }
`

export const CustomLoginInputNumberV2 = styled(InputNumber).attrs({
  ...CustomInputAttrsV2,
  style: { ...CustomInputAttrsV2.style, width: '100%' },
})`
  &::placeholder {
    color: #667085 !important;
  }
  &:hover {
    border-color: #d6dae0 !important;
  }
  &:focus {
    border-color: #0048b3 !important;
    box-shadow: 0 0 0 2px rgba(0, 72, 179, 0.2) !important;
  }
`

export const CustomSelectV2 = styled(Select).attrs({ ...CustomSelectAttrsV2 })`
  border: 1px solid #d6dae0;
  border-radius: 10px;

  & .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
    background: #fff;
    border-radius: 10px;
    padding: 8px 12px;
  }

  &::placeholder {
    color: #667085 !important;
  }
  &:hover {
    border-color: #d6dae0 !important;
  }
  &:hover .ant-select-selector {
    border: none !important;
  }
  &.ant-select-focused {
    border-color: #0048b3 !important;
    box-shadow: 0 0 0 2px rgba(0, 72, 179, 0.2) !important;
  }
  &.ant-select-focused .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }
`

export const CustomCheckboxV2 = styled(Checkbox)`
  & > .ant-checkbox {
    border-radius: 100%;
    overflow: hidden;
    border: 1px solid #0048b3;
  }
  & > .ant-checkbox:not(.ant-checkbox-checked) {
    border-radius: 100%;
    overflow: hidden;
    border: 1px solid #0048b3;
    & span.ant-checkbox-inner {
      background-color: transparent;
      border-color: transparent;
    }
  }
`

export const CustomDividerV2 = styled(Divider)`
  color: #0048b3 !important;
  border-top-color: #0048b3 !important;
`

export const CustomNationalitySelectV2 = styled(NationalitySelect).attrs({
  ...CustomSelectAttrsV2,
})`
  border: 1px solid #d6dae0;
  border-radius: 10px;

  & .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
    background: #fff;
    border-radius: 10px;
    padding: 8px 12px;
  }

  &::placeholder {
    color: #667085 !important;
  }
  &:hover {
    border-color: #d6dae0 !important;
  }
  &:hover .ant-select-selector {
    border: none !important;
  }
  &.ant-select-focused {
    border-color: #0048b3 !important;
    box-shadow: 0 0 0 2px rgba(0, 72, 179, 0.2) !important;
  }
  &.ant-select-focused .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }
`

export const CustomMobilePrefixSelectV2 = styled(MobileCountryCodeSelect).attrs({
  ...CustomSelectAttrsV2,
})`
  border: 1px solid #d6dae0;
  border-radius: 10px;

  & .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
    background: #fff;
    border-radius: 10px;
    padding: 8px 12px;
  }

  &::placeholder {
    color: #667085 !important;
  }
  &:hover {
    border-color: #d6dae0 !important;
  }
  &:hover .ant-select-selector {
    border: none !important;
  }
  &.ant-select-focused {
    border-color: #0048b3 !important;
    box-shadow: 0 0 0 2px rgba(0, 72, 179, 0.2) !important;
  }
  &.ant-select-focused .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }
`
